// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#openbay section.rating[data-v-7960925c]{margin-bottom:.5rem}#openbay section.rating svg.fa-star[data-v-7960925c]{width:.9375rem;margin-right:.2rem;color:#ffa52b}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
